/**
 * Account types the mutual-fund product does not support.
 *
 * Ported from the user platform's
 * `components/MutualFunds/MfUnsupportedAccountDialog.tsx`, where an investor on
 * one of these types is shown a dialog instead of the MF journey.
 *
 * The admin needs the same gate for a different reason: nothing stops an
 * operator opening the MF dashboard for an HUF or non-resident investor and
 * filling in an order the backend will refuse. Checking here turns that into a
 * sentence on screen before any work is done.
 *
 * The four spellings below are the ones the user directory actually returns for
 * the same two categories — an API-side inconsistency the user platform matches
 * literally, so this does too rather than trying to be clever about it.
 */

const UNSUPPORTED_MF_ACCOUNT_TYPES = [
  "Hindu Undivided Family",
  "Individual Non-Resident",
  "Non-Residential Individual",
  "individual_non_resident",
];

export const isMfUnsupportedAccountType = (
  accountType?: string | null
): boolean => UNSUPPORTED_MF_ACCOUNT_TYPES.indexOf(accountType || "") >= 0;

/** One line naming why, for a banner or a disabled control. */
export const mfUnsupportedAccountReason = (
  accountType?: string | null
): string =>
  isMfUnsupportedAccountType(accountType)
    ? `Mutual funds are not offered to ${accountType} accounts, so orders placed for this investor will be rejected.`
    : "";
